module.exports = __webpack_public_path__ + "static/media/beaconQueue.6c43a450.jpg";